import { type ICol, type ISection } from "src/interfaces";

const widgetHeaders = [
  {
    type: "col",
    name: "TIME",
    unit: "time",
    width: "10",
  },
  {
    type: "col",
    name: "USER",
    unit: "userref",
    width: "15",
  },
  {
    type: "col",
    name: "EVENT",
    unit: "large\/text",
    searchEntries: "event",
    width: "40",
  },
];

export const getWidgetHeaders = (h: any, override?: boolean) =>
  override
    ? widgetHeaders
    : h[0].name === "watchkeeper".toUpperCase()
      ? h
      : h.length < 3
        ? widgetHeaders
        : h;

const getWidgetRow = (r: any) =>
  Array.isArray(r)
    ? r
        .map((c: any) => {
          if (c && typeof c === "object" && "value" in c && "unit" in c) {
            if (typeof c.value === "object" && "full_name" in c.value) {
              c.value = {
                ...c.value,
                firstname: c.value.full_name.split(" ")[0] || "",
                surname: c.value.full_name.split(" ")[1] || "",
              };
              delete c.value.full_name;
            }
            return c;
          }
          const col = { type: "col" } as ICol;
          if (c?.time) {
            col.value = { time: c.time, type: c.type };
            col.unit = "time";
          } else if (c?.userid) {
            col.value = {
              userid: c.userid,
              firstname: c.full_name?.split(" ")[0] || "",
              surname: c.full_name?.split(" ")[1] || "",
              rolename: c.rolename,
            };
            col.unit = "user";
          } else if (typeof c === "string") {
            col.value = c;
            col.unit = "large/text";
            col.notes = "true";
          }
          return col;
        })
        .fill("", r.length, 3)
    : [];

export const getWidgetRows = (rows: any, rowUsers?: any) => {
  if (!rows) return [];
  if (typeof rows[0] === "object" && "cols" in rows[0]) {
    return rows.map((r: any) => {
      if (r.version === 1) {
        !r.cols[1].userid
          ? r.cols.splice(
              1,
              0,
              r.user
                ? `${r.user.ref} - ${r.user.rolename} ${r.user.full_name}`
                : "",
            )
          : Array.isArray(r.cols) && r.cols.length < 3 && r.cols.push("");
      }
      return { ...r, cols: getWidgetRow(r.cols) };
    });
  }
  if (rowUsers && Array.isArray(rowUsers)) {
    rows.map((r: any, i: number) =>
      Array.isArray(r) && r?.length < 3
        ? r.splice(1, 0, rowUsers[i] ? { userid: rowUsers[i] } : "")
        : r,
    );
  }
  return rows.map((r: any) => getWidgetRow(r));
};

export const getWidgetSections = (sections: any) => {
  if (!sections || !Array.isArray(sections)) return [];

  const widgetSections = (sections as ISection[])
    .map(s =>
      s.rows.filter(r => Array.isArray(r)).length > 0
        ? {
            ...s,
            headers: getWidgetHeaders(s.headers),
            rows: getWidgetRows(s.rows, s.rowUsers),
          }
        : {
            ...s,
            headers: getWidgetHeaders(s.headers),
            rows: [],
          },
    )
    .filter(s => s !== null);
  return widgetSections ?? [];
};
